module.exports = __webpack_public_path__ + "static/media/Element_14_treatments.2d72befc.svg";